export const GET_SUBSCRIPTION = "GET_SUBSCRIPTION_PLAN";
export const GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS";
export const GET_SUBSCRIPTION_FAIL = "GET_SUBSCRIPTION_FAIL";

export const GET_SUBSCRIPTION_BY_ID = "GET_SUBSCRIPTION_BY_ID";
export const GET_SUBSCRIPTION_BY_ID_SUCCESS = "GET_SUBSCRIPTION_BY_ID_SUCCESS";
export const GET_SUBSCRIPTION_BY_ID_ERROR = "GET_SUBSCRIPTION_BY_ID_ERROR";

export const CREATE_ORDER = "CREATE_ORDER";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_ERROR = "CREATE_ORDER_ERROR";

export const PAYMENT_INTENT = "PAYMENT_INTENT";
export const PAYMENT_INTENT_SUCCESS = "PAYMENT_INTENT_SUCCESS";
export const PAYMENT_INTENT_ERROR = "PAYMENT_INTENT_ERROR";

export const GET_PRICE_BY_ID = "GET_SUBSCRIPTION_BY_ID";
export const GET_PRICE_BY_ID_SUCCESS = "GET_PRICE_BY_ID_SUCCESS";
export const GET_PRICE_BY_ID_ERROR = "GET_PRICE_BY_ID_ERROR";
